module.exports = __webpack_public_path__ + "static/img/3.e0d4fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/briefing/3.png
// module id = 91rM
// module chunks = 1